import { useEffect } from "react";

export const Privacy = () => {
  useEffect(() => {
    window.location.href = "https://unocrm.kr/privacy";
  }, []);

  return null;
};
